export default __webpack_public_path__ + "static/media/idea.5550d5ce.png";